import { takeEvery } from 'redux-saga/effects';
import * as types from 'store/actions/types';
import config from 'helpers/config';
import apiClient from 'clients/apiClient';

function* reservationSessionStartAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        params,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/reservations/${ id }/session-start`;
        const response = yield apiClient.create(url, params);

        yield onSuccess(response);
    } catch (error) {
        yield onError(error);
    }
}

function* reservationSessionStopAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        params,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/reservations/${ id }/session-end`;
        const response = yield apiClient.create(url, params);

        yield onSuccess(response);
    } catch (error) {
        yield onError(error);
    }
}

function* reservationSessionOpenBarrierAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        params,
    } = payload;

    try {
        const response = yield apiClient.create(`${ config.getApiBaseUrl() }/reservations/${ id }/open-barrier`, params);

        yield onSuccess(response);
    } catch (error) {
        yield onError(error);
    }
}

export default function* reservationSessionSagas() {
    yield [
        takeEvery(types.RESERVATION_SESSION_START, reservationSessionStartAsync),
        takeEvery(types.RESERVATION_SESSION_STOP, reservationSessionStopAsync),
        takeEvery(types.RESERVATION_SESSION_OPEN_BARRIER, reservationSessionOpenBarrierAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/reservationSessionSagas.js